<script setup>
import { ref, onMounted, computed, reactive, onUnmounted } from 'vue';
import SkuPicker from '../SkuPicker.vue';
import { useIns } from '../../utils/v2_helper/common';
import { RECOMMEND_PRODUCT_INVALID } from '../../utils/config';
import { useRecommendData } from './util';

const app = useIns();

const skuRef = ref();
const { listData, routeScope, run } = useRecommendData();
const show = computed(() => listData.value.length > 0);

const skuPickerProps = reactive({
  productId: '',
  tag: '',
  historyData: '',
});
function onAdd(it) {
  skuPickerProps.productId = it.id;
  skuPickerProps.tag = `recommend_${routeScope.value}`;
  if (Array.isArray(it.defaultModifiers) && it.defaultModifiers?.length > 0) {
    skuPickerProps.historyData = encodeURI(JSON.stringify(it.defaultModifiers));
  }
  skuRef.value.visible = true;
}

onMounted(() => {
  app.$bus.$off(RECOMMEND_PRODUCT_INVALID, run);
  app.$bus.$on(RECOMMEND_PRODUCT_INVALID, run);
});
onUnmounted(() => {
  app.$bus.$off(RECOMMEND_PRODUCT_INVALID, run);
});
</script>

<template>
  <div v-if="show" class="recommend">
    <slot :count="listData.length" />
    <div>
      <div class="recommend-list">
        <div v-for="(it, i) of listData" :key="i" class="recommend-list-item">
          <img class="item-avatar" :src="it.image" />
          <div class="item-info">
            <span bold break class="item-info-tile dot2">{{ it.name }}</span>
            <div class="item-info-bottom">
              <span v-if="it.listPrice !== it.price" class="item-info-del">
                {{ $pid(it.listPrice) }}
              </span>
              <div class="item-lastline">
                <span bold class="item-info-price">
                  {{ $pid(it.price) }}
                </span>
                <div class="item-action" @click="onAdd(it)">
                  <i class="iconfont dm-Add1" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--用作 orderAgain 弹窗的位置-->
    <!-- <router-view :list="listData" /> -->
    <SkuPicker
      ref="skuRef"
      :product-id="skuPickerProps.productId"
      :tag="skuPickerProps.tag"
      :history-data="skuPickerProps.historyData"
    />
  </div>
</template>

<style lang="scss" scoped>
.recommend {
  background: #fff;
  padding: 16px 12px;
  border-top: solid 1px $border-lg;
  &-list {
    display: flex;
    flex-wrap: nowrap;
    background: #fff;
    overflow-x: scroll;
    &-item {
      display: flex;
      min-width: 204px;
      max-width: 225px;
      flex-shrink: 0;
      & + & {
        margin-left: 16px;
      }
      .item-avatar {
        width: 80px;
        height: 80px;
        border-radius: $border-radius-3;
      }
      .item-info {
        display: flex;
        flex-direction: column;
        padding: 8px 0 8px 8px;
        font-size: 12px;
        flex: 1;
        &-tile {
          margin-bottom: auto;
          line-height: 1.2;
        }
        &-del {
          text-decoration: line-through;
          color: $grayFont;
          margin-top: auto;
        }
        &-price {
          font-size: 14px;
        }
        &-bottom {
          .item-lastline {
            width: 100%;
            display: flex;
            align-items: center;
            line-height: 18px;
          }
        }
      }
      .item-action {
        margin-left: auto;
        align-self: flex-end;
        .iconfont {
          font-size: 20px;
          color: #0f131e;
        }
      }
    }
  }
  &-list::-webkit-scrollbar {
    display: none;
  }
}
</style>
